import { render } from "./TrainingRncpComponent.vue?vue&type=template&id=1cb6099e"
import script from "./TrainingRncpComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__